import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = null as MemberOffer | Offer | null;

const slice = createSlice({
  name: 'loyaltySelectedOffer',
  initialState,
  reducers: {
    setLoyaltySelectedOffer(state, action: PayloadAction<MemberOffer | Offer | null>) {
      return action.payload || initialState;
    },
  },
});

export const { setLoyaltySelectedOffer } = slice.actions;

export default slice.reducer;
